import { Injectable } from '@angular/core';

import { environment } from '@coin-depo-config/environments/core-env/environment'

@Injectable({
  providedIn: 'root'
})
export class CookieService {
    set(
        name: string,
        value: string,
        options: {
            expires?: Date | number | string;
            path?: string;
            domain?: string;
            secure?: boolean;
            sameSite?: 'Lax' | 'Strict' | 'None';
        } = {}
    ): void {
        if (value === undefined) return;
        let cookieStr = `${name}=${encodeURIComponent(value)};`;

        if (options.expires) {
            let expiresStr: string;
            if (options.expires instanceof Date) {
            expiresStr = options.expires.toUTCString();
            } else if (typeof options.expires === 'number') {
            const date = new Date();
            date.setTime(date.getTime() + options.expires * 86400000);
            expiresStr = date.toUTCString();
            } else {
            expiresStr = new Date(options.expires).toUTCString();
            }

            cookieStr += ` expires=${expiresStr};`;
        }

        cookieStr += ` path=${options.path ?? '/'};`;

        if (options.domain) cookieStr += ` domain=${options.domain};`;
        if (options.sameSite) cookieStr += ` SameSite=${options.sameSite};`;
        if (options.secure) cookieStr += ' Secure;';

        document.cookie = cookieStr;
    }


    get(name: string): string {
        const arr = document.cookie.split(';');
        for (let cookie of arr) {
        cookie = cookie.trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
        }
        return "";
    }

    delete(name: string, path: string = '/', domain?: string): void {
        const domainStr = domain ? `; domain=${domain}` : "";
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domainStr}`;
    }

    deleteAll(): void {
        const cookies = document.cookie.split(';');

        const domains = [
            undefined,
            window.location.hostname,
            this.getRootDomain(),      // coindepo.io
            '.' + this.getRootDomain() // .coindepo.io
        ];

        const paths = ['/', '/auth', '/dashboard', '/verify', '/login'];

        for (const cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

            for (const d of domains) {
            for (const p of paths) {
                this.delete(name, p, d);
            }
            }
        }
    }

    clearAllCookies(): void {
        const cookies = document.cookie.split(";");

        const paths = location.pathname
        .split("/")
        .filter(Boolean)
        .map((_, i, arr) => "/" + arr.slice(0, i + 1).join("/"));

        const domains = [
        this.extractDomain(environment.serverUrl),
        this.extractDomain(environment.serverAuthUrl),
        this.extractDomain(environment.landingUrl),
        this.extractDomain(environment.staticUrlIcon),
        window.location.hostname,
        "." + window.location.hostname,
        ...window.location.hostname.split(".").length > 2
            ? ["." + window.location.hostname.split(".").slice(1).join(".")]
            : []
        ];

        for (const cookie of cookies) {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

            for (const path of ["/", ...paths]) {
                for (const domain of domains) {
                document.cookie =
                    `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
                }
            }

            for (const path of ["/", ...paths]) {
                document.cookie =
                `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
            }
        }
    }
    

    private extractDomain (url: string): string | null {
        try {
        return new URL(url).hostname;
        } catch (e) {
        return null;
        }
    };

    private getRootDomain(): string {
        const parts = location.hostname.split('.');
        return parts.slice(-2).join('.');
    }
}